export const truncate = (str, size) => {
    return str.length > size ?
        str[size - 4] === ',' || str[size - 4] === '.' ? str.substring(0, (size - 1)) + "..." :
            str.substring(0, (size - 3)) + "..."
        : str;
};